module.exports = __webpack_public_path__ + "static/media/8.bd6e41a5.jpg";